export const UNIT_SIGNAL_STRENGTH_GRID_CONFIG_ID = 'unit-dash-unit-signal-strength'

export const UNIT_SIGNAL_STRENGTH_GRID_CONFIG = {
  id: UNIT_SIGNAL_STRENGTH_GRID_CONFIG_ID,
  layout: {
    xxl: { i: UNIT_SIGNAL_STRENGTH_GRID_CONFIG_ID, x: 0, y: 3.15, w: 8.25, h: 2.25, static: true },
    xl: { i: UNIT_SIGNAL_STRENGTH_GRID_CONFIG_ID, x: 5, y: 3.15, w: 5, h: 2.25, static: true },
    lg: { i: UNIT_SIGNAL_STRENGTH_GRID_CONFIG_ID, x: 5.5, y: 3.35, w: 5, h: 2.25, static: true },
    md: { i: UNIT_SIGNAL_STRENGTH_GRID_CONFIG_ID, x: 6, y: 3.25, w: 6, h: 2.25, static: true },
    sm: { i: UNIT_SIGNAL_STRENGTH_GRID_CONFIG_ID, x: 6, y: 3.25, w: 6, h: 2.25, static: true },
    xs: { i: UNIT_SIGNAL_STRENGTH_GRID_CONFIG_ID, x: 0, y: 5.05, w: 12, h: 2.25, static: true },
    xxs: { i: UNIT_SIGNAL_STRENGTH_GRID_CONFIG_ID, x: 0, y: 6, w: 12, h: 5, static: true }
  }
}
